const PlayerComplaintActionType = {
  GET_PLAYER_COMPLAINTS: 'GET_PLAYER_COMPLAINTS',
  SAVE_PLAYER_COMPLAINTS: 'SAVE_PLAYER_COMPLAINTS',
  RESET_PLAYER_COMPLAINTS: 'RESET_PLAYER_COMPLAINTS',
  GENERATE_PLAYER_COMPLAINTS_REPORT: 'GENERATE_PLAYER_COMPLAINTS_REPORT',
  CHANGE_PLAYER_COMPLAINTS_STATUS: 'CHANGE_PLAYER_COMPLAINTS_STATUS',
};

export default PlayerComplaintActionType;
